import wellknown from "wellknown";
import React, { useEffect, useState } from "react";
import { Polygon, Polyline, Circle, OverlayView } from "@react-google-maps/api";

// import { map } from './Map';
import { useEffectAsync } from "../reactHelper";
import { parseCoordinates } from "./mapUtil";
const center = { lat: 24.886, lng: -70.268 };

const paths = [
  { lat: 25.774, lng: -80.19 },
  { lat: 18.466, lng: -66.118 },
  { lat: 32.321, lng: -64.757 },
  { lat: 25.774, lng: -80.19 },
];

const GeofenceMap = () => {
  const id = "geofences";

  const [geofences, setGeofences] = useState([]);

  const onLoad = (polygon) => {
    // console.log("polygon: ", polygon);
  };
  useEffectAsync(async () => {
    const response = await fetch("/api/geofences");
    if (response.ok) {
      setGeofences(await response.json());
    }
  }, []);

  const renderPolygon = () => {
    const circleList = geofences.filter(
      (item) => item.area && item.area.includes("CIRCLE")
    );
    const list = geofences
      .map((item) => [
        item.name,
        parseCoordinates(wellknown(item.area)),
        item.attributes.color || "#22B410",
      ])
      .filter(([, geometry]) => !!geometry)
      .map(([name, geometry, color]) => ({
        type: "Feature",
        geometry: geometry,
        properties: { name },
        color: { color },
      }));

    const overlayStyle = {
      background: "#371dda",
      border: "1px solid #371dda",
      padding: 1,
      // position: "absolute",
      top: "10px",
      left: "-15px",
      borderRadius: "3px",
      // marginLeft:'-10px',
    };

    const circles = circleList.map((item) => {
      const content = item.area.match(/\([^()]+\)/);
      let circleShape = "";
      if (content !== null) {
        const coordinates = content[0].match(/-?\d+\.?\d*/g);

        const circleCenter = {
          lat: Number(coordinates[0]),
          lng: Number(coordinates[1]),
        };
        const radius = Number(coordinates[2]);
        const color = item.attributes.color || "#22B410";
        overlayStyle.background = color;
        const circleOptions = {
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.35,
          clickable: false,
          draggable: false,
          editable: false,
          visible: true,
          radius: radius,
          zIndex: 1,
        };
        circleShape = (
          <OverlayView
            position={circleCenter}
            mapPaneName={OverlayView.FLOAT_PANE}
          >
            <>
              <div style={{ ...overlayStyle }}>{item.name}</div>
              <Circle
                onLoad={onLoad}
                center={circleCenter}
                options={circleOptions}
              ></Circle>
            </>
          </OverlayView>
        );
      }
      return circleShape;
    });

    const otherShapes = list.map((item) => {
      // console.log(item);
      const { color } = item.color || {};
      let geofences = "";
      const {
        geometry: { coordinates, type },
      } = item;
      const shape = (type === "LineString" && coordinates) || coordinates[0];
      const latLngCoordinates = shape.map((coordinateItem) => {
        const item = {
          lat: coordinateItem[0],
          lng: coordinateItem[1],
        };
        return item;
      });
      let InfoWindowCordinates = {};
      overlayStyle.background = color;

      switch (type) {
        case "Polygon":
          InfoWindowCordinates = latLngCoordinates.reduce(
            (previousValue, currentValue) => {
              return {
                lat: previousValue.lat + currentValue.lat,
                lng: previousValue.lng + currentValue.lng,
              };
            }
          );
          InfoWindowCordinates.lat =
            InfoWindowCordinates.lat / latLngCoordinates.length;
          InfoWindowCordinates.lng =
            InfoWindowCordinates.lng / latLngCoordinates.length;
          const options = {
            strokeOpacity: 0.8,
            fillColor: color,
            fillOpacity: 0.35,
            strokeColor: color,
            strokeWeight: 2,
            clickable: false,
            draggable: false,
            editable: false,
            geodesic: false,
            zIndex: 1,
          };
          geofences = (
            <>
              <OverlayView
                position={InfoWindowCordinates}
                mapPaneName={OverlayView.FLOAT_PANE}
              >
                <>
                  <div style={{ ...overlayStyle }}>{item.properties?.name}</div>
                  <Polygon
                    onLoad={onLoad}
                    paths={latLngCoordinates}
                    options={options}
                  />
                </>
              </OverlayView>
            </>
          );
          break;
        case "LineString":
          InfoWindowCordinates =
            latLngCoordinates[Math.floor(latLngCoordinates.length / 2)];
          const polyLineOptions = {
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
            clickable: false,
            draggable: false,
            editable: false,
            visible: true,
            radius: 30000,
            paths: latLngCoordinates,
            zIndex: 1,
          };
          geofences = (
            <OverlayView
              position={InfoWindowCordinates}
              mapPaneName={OverlayView.FLOAT_PANE}
            >
              <>
                <div style={{ ...overlayStyle }}>{item.properties?.name}</div>
                <Polyline
                  onLoad={onLoad}
                  path={latLngCoordinates}
                  options={polyLineOptions}
                />
              </>
            </OverlayView>
          );
          break;
        default:
          break;
      }

      return geofences;
    });

    return [...otherShapes, ...circles];
  };

  return <>{renderPolygon()}</>;
};

export default GeofenceMap;
